// extracted by mini-css-extract-plugin
module.exports = {"image":"wagepoint-module--image---g7aH","link":"wagepoint-module--link--2gLGi"};